import { Row, Typography } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';

import { IItemField } from '../../../../SimuladorInteligente/interfaces';
import BaseNodeContainer from '../../BaseNodeContainer';

export default function CollectNode(node: any) {

  const fields = node.data.fields as IItemField[] | undefined;

  return (
    <>
      <BaseNodeContainer
        title='Coleta de dados'
        node={node}
        IconComponent={<FileTextOutlined />}
        onPressLink={node.onPressAddLinkedNode}
        defaultMessages={node.defaultMessages}
        defaultInputInstructions={node.defaultInputInstructions}
      >
        <div
          style={{
            padding: "0px 12px 4px"
          }}
        >
          <Typography.Title level={5}>Informações:</Typography.Title>

          <Row
            style={{
              flexDirection: 'column',
            }}
          >
            {
              fields?.map((e: any) => (
                <Typography.Text key={e.name}>{e.label}</Typography.Text>
              ))
            }
          </Row>
        </div>
      </BaseNodeContainer>
    </>
  );
}